import overlayView from './overlayComponent.html';
import './overlayComponent.css';
import _ from 'lodash';

export function overlayComponent() {
	return {
		bindings: {
			onto: '<',
			when: '=',
			onClose: '&?',
		},
		controllerAs: 'vm',
		transclude: true,
		controller: overlayComponentCtrl,
		template: overlayView,
	};
}

export class overlayComponentCtrl {
	constructor($scope, $element) {
		'ngInject';
		this.element = $element[0];
		$scope.$watch('vm.when', () => this.toggle());
	}

	$onChanges(changes) {
		if (changes.onto) {
			const onto = document.querySelector(this.onto);
			if (onto) {
				onto.appendChild(this.element);
			}
		}
	}

	$onDestroy() {
		try {
			this.element.parentNode.removeChild(this.element);
		} catch (e) {}
	}

	toggle() {
		if (this.when && !_.includes(['fixed', 'absolute'], this.element.parentNode.style.position)) {
			this.element.parentNode.style.position = 'relative';
		}
		this.element.style.display = this.when ? '' : 'none';
	}

	close() {
		this.when = false;
		this.onClose && this.onClose();
	}
}
